import { useMemo, useCallback } from 'react'
import CustomTable from '../../../components/CustomTable/CustomTable'
import { formatCurrency } from '../../../helpers/helpers'
import { safeDateSort } from '../../../helpers/sortHelpers'

const SettleDealTable = ({
    data,
    selectedRowKeys,
    setSelectedRowKeys
}) => {
    const onSelectChange = useCallback(
        (newSelectedRowKeys) => { setSelectedRowKeys(newSelectedRowKeys); }, [setSelectedRowKeys]
    );

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        fixed: "left",
    };

    const columns = useMemo(() => [
        {
            title: 'Deal ID',
            dataIndex: 'dealId',
            key: 'dealId',
        },
        {
            title: 'Enterprise',
            dataIndex: 'entName',
            key: 'entName',
            ellipsis: false,
            render: (text) => (
                <span style={{ whiteSpace: 'nowrap' }}>
                    {text}
                </span>
            )
        },
        {
            title: 'Due Date',
            dataIndex: 'dueDate',
            key: 'dueDate',
            sorter: (a, b) => safeDateSort(a?.dueDate, b?.dueDate),
            render: (value) => value ? value.split("-").reverse().join("/") : "-"
        },
        {
            title: 'Invoice Amount',
            dataIndex: 'invoiceAmt',
            key: 'invoiceAmt',
            width: 200,
            render: (v) => formatCurrency(v),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Open Balance',
            dataIndex: 'openBalance',
            key: 'openBalance',
            width: 170,
            fixed: "right",
            render: (v) => formatCurrency(v),
        },
    ], [])

    return (
        <CustomTable
            dataSource={data?.deals}
            columns={columns}
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            rowKey="dealId"
            tableContainerStyle='settle-deal-table-container'
            tableStyle='settle-deal-table'
        />
    )
}

export default SettleDealTable